import { gql, useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import app from "../axiosConfig";
import CourseInfoTile from "../components/CourseInfoTile";
import CreateMessageFAB from "../components/CreateMessageFAB";
import Loader from "../components/Loader";
import MessageTile from "../components/MessageTile";
import { addToastMsg } from "../redux/auth/authActions";

const CHANGE_MESSAGE_LAST_VISITED = gql`
  mutation (
    $id: String!
    $class_id: String!
    $course_id: String!
    $faculty_id: String!
  ) {
    changeMessageLastVisited(
      id: $id
      class_id: $class_id
      course_id: $course_id
      faculty_id: $faculty_id
    )
  }
`;

function CourseMessages() {
  const params = useParams();
  const dispatch = useDispatch();
  const role = useSelector((state) => state.auth?.user?.role);
  const userId = useSelector((state) => state.auth?.user?.userId);
  const [messages, setMessages] = useState([]);
  const [loader, setLoader] = useState(true);

  const course = useSelector((state) =>
    state.pwaData?.courses.find((course) =>
      role === "Student"
        ? course.course_id.course_code === params.course_code
        : course.course_code === params.course_code
    )
  );
  const studentMessages = useSelector((state) =>
    state.pwaData?.messages.filter(
      (msg) =>
        msg.course === course?.course_id._id &&
        msg.classes.includes(course?.class_id._id) &&
        msg.faculty === course?.faculty_id._id
    )
  );
  const [changeMessageLastVisited] = useMutation(CHANGE_MESSAGE_LAST_VISITED);

  const fetchMessages = async () => {
    try {
      if (!course) return;
      const { data } = await app.get("/pwa/fetch-messages/" + params.class_id, {
        params: {
          course: course?._id || course?.course_id._id,
          faculty: role === "Student" ? course?.faculty_id.userId : userId,
        },
      });
      setMessages(data);
      setLoader(false);
    } catch (error) {
      dispatch(addToastMsg(error.response.data.message, "error"));
    }
  };

  const checkAndChangeMessageLastVisited = () => {
    if (role === "Student") {
      if (course) {
        changeMessageLastVisited({
          variables: {
            id: userId,
            class_id: course?.class_id._id,
            course_id: course?.course_id._id,
            faculty_id: course?.faculty_id._id,
          },
        });
      }
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    role === "Faculty" ? fetchMessages() : setLoader(false);
    // eslint-disable-next-line
  }, [course]);

  useEffect(() => {
    checkAndChangeMessageLastVisited();

    return () => {
      checkAndChangeMessageLastVisited();
    };

    // eslint-disable-next-line
  }, [course]);

  if (!course || loader) {
    return <Loader />;
  }

  return (
    <div className="body-container">
      <CourseInfoTile course={course} />
      {messages.length === 0 && studentMessages.length === 0 ? (
        <div className="no-schedule">No messages yet</div>
      ) : role === "Faculty" ? (
        messages.map((message) => (
          <MessageTile key={message._id} message={message} />
        ))
      ) : (
        studentMessages.map((message) => (
          <MessageTile key={message.id} message={message} />
        ))
      )}
      {role === "Faculty" && <CreateMessageFAB course={course} />}
    </div>
  );
}

export default CourseMessages;
